export const en = {
    'banners-language-geo-error':
        "The selected language doesn't match the display region in one of the campaign's ad groups",
    'daily-budget-change-limit': {
        one: 'You cannot change your daily budget more than {count} time per day',
        some: 'You cannot change your daily budget more than {count} times per day',
        many: 'You cannot change your daily budget more than {count} times per day',
        none: 'You cannot change your daily budget more than {count} times per day'
    },
    'default-error': 'Fill in information correctly',
    'email-error': 'incorrect email',
    'invalid-domain-or-ssp': 'Invalid site or ad exchange: {subset}',
    'ip-from-private-network-message': "You can't block IP addresses from private networks: {subset}",
    'ip-from-yandex-network-message':
        "You don't need to add IP addresses from the Yandex subnetwork to the list of forbidden addresses. Impressions and clicks from these IP addresses are not counted in campaign statistics: {subset}",
    'metrika-counter-is-unavailable':
        "You selected a Yandex.Metrica tag that can't be linked to the campaign. Either the tag was deleted or you don't have access rights.",
    'metrika-error': 'An error occurred while saving the campaign. Please try again',
    'name-cannot-be-null': 'Specify the campaign name',
    'name-enabled-symbols': 'Campaign name may only contain letters, numbers, and punctuation marks',
    'name-max-length': 'Maximum length of the campaign name is {maxLength} characters',
    'organization-deleted-err':
        'This business was removed from Yandex Business Directory. Add a different one or create a new one',
    'pay-for-conversion-day-budget-error': 'При оплате за конверсии дневной бюджет на общем счете запрещен',
    'pay-for-conversion-error': 'Pay per conversion is not available. The campaign has ads without turbo page landings',
    'roi-meaningful-goals-error':
        'Optimization for all priority goals is not available because priority goals are not set, or only engaged sessions are set.',
    'unknown-ssp': 'Unknown ad platform: {subset}',
    'vcard-city-letters': 'Name of city may only contain letters',
    'vcard-city-max-length': 'Name of city may not exceed {maxLength} characters',
    'vcard-city-no-empty': 'Enter a city',
    'vcard-country-letters': 'Name of country may only contain letters',
    'vcard-country-max-length': 'Name of country may not exceed {maxLength} characters',
    'vcard-country-no-empty': 'Enter a country',
    'vcard-descr-format': 'Description may only contain letters, numbers, and punctuation marks',
    'vcard-descr-max-length': 'Description may not exceed {maxLength} characters',
    'vcard-descr-no-empty': 'Enter a description',
    'vcard-house-max-length': 'House number may not exceed {maxLength} characters',
    'vcard-house-no-empty': 'Enter a house number',
    'vcard-mail-format': 'Invalid email address',
    'vcard-mail-max-length': 'Email address may not exceed {maxLength} characters',
    'vcard-mail-no-empty': 'Enter an email address',
    'vcard-messenger-icq-format': 'Invalid ICQ username',
    'vcard-messenger-jabber-format': 'Invalid JABBER username',
    'vcard-messenger-login-length': 'Username may not exceed {maxLength} characters',
    'vcard-messenger-mailruagent-format': 'Invalid Mail.Ru Agent username',
    'vcard-messenger-skype-or-msn-format': 'Invalid username',
    'vcard-name-letters': 'Name may only contain letters, numbers, and punctuation marks',
    'vcard-name-max-length': 'Name may not exceed {maxLength} characters',
    'vcard-name-no-empty': 'Enter a company name',
    'vcard-office-format': 'Office numbers may only contain letters, numbers, and punctuation marks',
    'vcard-office-max-length': 'The number of characters in this field may not exceed {maxLength}',
    'vcard-office-no-empty': 'Enter an office number',
    'vcard-ogrn-format': 'Invalid OGRN/OGRNIP',
    'vcard-ogrn-no-empty': 'Enter an OGRN/OGRNIP',
    'vcard-phone-city-code-format': 'Invalid area code',
    'vcard-phone-city-code-length': 'City code may not exceed {maxLength} characters',
    'vcard-phone-city-code-no-empty': 'Enter a city code',
    'vcard-phone-country-code-format':
        'Country code must start with "+" and contain from 1 to 4 numbers. Country code 8 may also be used in combination with regional code 800.',
    'vcard-phone-country-code-length': 'Country code may not exceed {maxLength} characters',
    'vcard-phone-country-code-no-empty': 'Enter a country code',
    'vcard-phone-country-code-start-no-plus':
        'Country code may be 8 or 0. In combination with regional codes, 8 800, 8 804, and 0 800 may be entered.',
    'vcard-phone-country-code-start-plus': 'Enter a "+" before the country code',
    'vcard-phone-extension-format': 'Invalid extension',
    'vcard-phone-extension-max-length': 'Extension may not exceed {maxLength} characters',
    'vcard-phone-number-format': 'Invalid phone number',
    'vcard-phone-number-max-length': 'Phone number may not exceed {maxLength} characters',
    'vcard-phone-number-min-length': 'Phone number must contain at least {minLength} characters',
    'vcard-phone-number-no-empty': 'Enter a phone number',
    'vcard-street-letters': 'Street name may only contain letters, numbers, and punctuation marks',
    'vcard-street-max-length': 'Street name may not exceed {maxLength} characters',
    'vcard-street-no-empty': 'Enter a street',
    'week-budget-less-than-avg-click': 'Average CPC cannot exceed the weekly budget',
    'week-budget-less-than-avg-cpa': 'Average CPA cannot exceed the weekly budget',
    'week-budget-less-than-max-click': 'Maximum CPC cannot exceed the weekly budget'
};
